import LightWeightDashboard from "../../Components/LightWeightCustomer/LightWeightDashboard";

export default function LightWeightDashboards(){
    return(
        <LightWeightDashboard/>
    )
}